import React, { RefObject, useCallback, VFC } from 'react';

import { Button } from 'mintel-react-ui';
import { utils, writeFile } from 'xlsx';

import useTranslate from '/utils/translations';

type TableDownloadProps = {
  tableRef: RefObject<HTMLTableElement>;
  filename: string;
};

const TableDownload: VFC<TableDownloadProps> = ({ tableRef, filename }) => {
  const t = useTranslate();

  const downloadHandler = useCallback(() => {
    if (tableRef?.current) {
      const workbook = utils.table_to_book(tableRef.current);
      writeFile(workbook, filename);
    }
  }, [tableRef, filename]);

  return (
    <Button.DownloadButton handleClick={downloadHandler}>
      {t('Download table (.csv)')}
    </Button.DownloadButton>
  );
};

export default TableDownload;
